/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Networks_List_Region_Filter_LabelInputs */

const fr_networks_list_region_filter_label = /** @type {(inputs: Networks_List_Region_Filter_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrer par région`)
};

const en_networks_list_region_filter_label = /** @type {(inputs: Networks_List_Region_Filter_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter by region`)
};

/**
* | output |
* | --- |
* | "Filter by region" |
*
* @param {Networks_List_Region_Filter_LabelInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const networks_list_region_filter_label = /** @type {((inputs?: Networks_List_Region_Filter_LabelInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Networks_List_Region_Filter_LabelInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_networks_list_region_filter_label(inputs)
	return en_networks_list_region_filter_label(inputs)
});